import { gql } from '@apollo/client';

import { OrderDetailsBaseFragment } from './orderDetailsFragment.gql';

/**
 * Fragment for pagination information in connection-based queries
 */
export const PageInfoFragment = gql`
  fragment PageInfoFragment on PageInfo {
    hasNextPage
    hasPreviousPage
    startCursor
    endCursor
  }
`;

/**
 * Fragment for order search results (minimal fields for search)
 */
export const OrderDetailsSearchFragment = gql`
  fragment OrderDetailsSearchFragment on Order {
    ...OrderDetailsBaseFragment
  }
  ${OrderDetailsBaseFragment}
`;

/**
 * Fragment for a single edge in the search order connection
 */
export const SearchOrderEdgeFragment = gql`
  fragment SearchOrderEdgeFragment on SearchOrderEdge {
    cursor
    node {
      ...OrderDetailsSearchFragment
    }
  }
  ${OrderDetailsSearchFragment}
`;

/**
 * Complete fragment for search order connection including edges and pagination info
 */
export const SearchOrderConnectionFragment = gql`
  fragment SearchOrderConnectionFragment on SearchOrderConnection {
    total
    edges {
      ...SearchOrderEdgeFragment
    }
    pageInfo {
      ...PageInfoFragment
    }
  }
  ${SearchOrderEdgeFragment}
  ${PageInfoFragment}
`;
